import type { ReactElement } from 'react';
import useAddresses from '../../hooks/useAddresses';
import Checkbox from '../shared/Checkbox';
import { patch } from '../../utils/network';
import FetchState from '../../models/FetchState';
import { ApiRoute } from '../../config';
import useCurrentUser from '../../hooks/useCurrentUser';

function NotificationPreference(): React.ReactElement | null {
  const { addresses, reload: reloadAddresses, fetchState } = useAddresses();
  const primaryAddress = addresses && addresses[0];
  const isAddressLoading = fetchState === FetchState.IN_PROGRESS;
  const { currentUser } = useCurrentUser();
  const hasSmsSubscription = !isAddressLoading && primaryAddress;

  const toggleSmsSubscriptionStatus = async (smsSubscription: string) => {
    const status = primaryAddress[smsSubscription] === 'sms_opted_in' ? 'sms_opted_out' : 'sms_opted_in';
    const payload = {
      shipping_address: { [smsSubscription]: status },
    };
    await patch(`${ApiRoute.SHIPPING_ADDRESSES}/${primaryAddress.id}`, payload);

    reloadAddresses();
  };

  if (!hasSmsSubscription) {
    return null;
  }

  return (
    <div className="col col-md-9 col-lg-10" style={{ display: 'flex', justifyContent: 'center' }}>
      <div className="c-my-account__notification c-my-account__notification__container">
        <div className="c-card c-my-account__notification__card">
          <div className="c-card__content">
            <h2 className="c-my-account__notification__card__heading">
              Notifications
            </h2>

            <div className="c-my-account__notification__checkboxs">
              <div className="c-my-account__notification__checkbox-card">
                <Checkbox
                  id="add-account-alerts"
                  label="Account Notifications"
                  disabled={currentUser.isDeactivated}
                  checked={
                              primaryAddress.sms_notification_status === 'sms_opted_in'
                          }
                  onChange={() => toggleSmsSubscriptionStatus('sms_notification_status')}
                />
                <p className="c-my-account__notification__checkbox-info">
                  Get order updates, tracking details, and other important account alerts.
                </p>
              </div>
              <div className="c-my-account__notification__checkbox-card">
                <Checkbox
                  id="add-offers-alerts"
                  label="Offers and Updates"
                  disabled={currentUser.isDeactivated}
                  checked={
                              primaryAddress.sms_offers_status === 'sms_opted_in'
                          }
                  onChange={() => toggleSmsSubscriptionStatus('sms_offers_status')}
                />
                <p className="c-my-account__notification__checkbox-info">
                  Receive exclusive deals, personalized menu recommendations, and more!
                </p>
              </div>
            </div>
            <p className="c-my-account__notification__disclaimer">
              By opting-in, you agree to receive recurring, automated promotional
              and personalized marketing text messages and/or important account
              updates from Purple Carrot at the phone number used when signing up.
              Message frequency will vary—don&apos;t worry we promise not to spam you!
              Message and data rates will apply. Reply HELP for help or STOP to cancel.
              nConsent is not a condition of purchase. View&nbsp;
              <a
                target="_blank"
                rel="noreferrer"
                href="/terms"
              >
                Terms & Conditions
              </a>
                    &nbsp;and&nbsp;
              <a
                target="_blank"
                rel="noreferrer"
                href="/privacy"
              >
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationPreference;
